export const FETCH_USERINFO_SUCCESS = "FETCH_USERINFO_SUCCESS";
export const FETCH_USERINFO_FAILURE = "FETCH_USERINFO_FAILURE";
export const FETCH_ORDER_SUCCESS="FETCH_ORDER_SUCCESS";
export const FETCH_ORDER_FAILURE="FETCH_ORDER_FAILURE";

export const FETCH_CURRENTBALANCE_SUCCESS="FETCH_CURRENTBALANCE_SUCCESS";
export const FETCH_CURRENTBALANCE_REQUEST="FETCH_CURRENTBALANCE_REQUEST";
export const FETCH_CURRENTBALANCE_FAILURE="FETCH_CURRENTBALANCE_FAILURE";

export const FETCH_CANCEL_SUCCESS="FETCH_CANCEL_SUCCESS";
export const FETCH_CANCEL_REQUEST="FETCH_CANCEL_REQUEST";
export const FETCH_CANCEL_FAILURE="FETCH_CANCEL_FAILURE";

export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_ORDER_REQUEST = "FETCH_ORDER_REQUEST";

export const FETCH_CONFIRM_REQUEST="FETCH_CONFIRM_REQUEST";
